"use client";

import { Breadcrumbs } from "@/components/common/breadcrumbs";
import { type SellerUnitsAndProjectsOne } from "@/types/sup";
import { buildSupOrProjectBreadcrumbItems } from "@/utils/breadcrumbs/sup";
import { type BreadcrumbItem } from "@/utils/breadcrumb-utils";
import { useRouter } from "next/navigation";
import { useMemo } from "react";

interface BreadcrumbsWrapperProps {
	city?: string;
	slug?: string;
	className?: string;
	supOne?: SellerUnitsAndProjectsOne;
	projectDetails?: {
		projectName: string;
	};
}

// for unit and project pages only, not for search page
export function BreadcrumbsWrapper({ city, slug, className, supOne, projectDetails }: BreadcrumbsWrapperProps) {
	const router = useRouter();

	// Build breadcrumb items with href using shared util
	const breadcrumbItems = useMemo(() => {
		return buildSupOrProjectBreadcrumbItems({ city, slug, supOne, projectDetails });
	}, [city, slug, supOne, projectDetails]);

	// Handle breadcrumb clicks - use router for navigation
	const handleBreadcrumbClick = (item: BreadcrumbItem) => {
		if (item.href) {
			if (item.variant === "city") {
				// Use window.location for clean navigation that resets search state
				window.location.href = item.href;
			} else {
				router.push(item.href);
			}
		}
	};

	return (
		<div className={className}>
			<Breadcrumbs items={breadcrumbItems} onBreadcrumbClick={handleBreadcrumbClick} />
		</div>
	);
}
